import { PriorityStockItem } from "../common/PriorityStockItem";

export const groupByPriorityStockFlag = (priorityStock: Array<PriorityStockItem>, items: any) => {
	return priorityStock.reduce((accumulator, currentValue) => {
		if (!accumulator[currentValue.flag])
			accumulator[currentValue.flag] = {
				flag: currentValue.flag,
				priority: currentValue.priority,
				items: [],
			};
		const item = items.find((i) => i.sku === currentValue.sku);
		if (item) {
			accumulator[currentValue.flag].items.push({
				...item,
				reason: currentValue.reason,
			});
		}
		return accumulator;
	}, {});
};
